import React from 'react';
import classNames from 'classnames';
import FlagFireworks from './FlagFireworks';

export default function ProgressCTA(props) {
  const { tenant, milestoneText, overRideStyle } = { ...props };

  return (
    <div data-cy="miletsone" className={['milestone', overRideStyle].join(' ')}>
      <div
        className={classNames({
          'milestone-icon': true,
          'milestone-icon--hidden': !milestoneText,
        })}
      >
        <FlagFireworks secondary={tenant.secondary} primary={tenant.primary} />
      </div>
      <p className="milestone-text">{milestoneText}</p>
    </div>
  );
}
